import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    oaAddr: 'http://127.0.0.1:8080', // 正式地址：http://oa.hkce.cn:1688
    // 生产环境必须将url、token、openid设置为空
    // url : 'http://app.ecms.gczj.com.cn/dev371',
    // url: 'http://192.168.0.162:8666',
    // token: 'df5de13919ce4e3fa121a675af1ddfdf',
    url: '',
    token: '',
    userInfo: {},
    isLogin: false,
    openId: '', // 微信openId（程乾openid okXhOwlGYstPvjS0gmkZJZQRIWOU）
    todoTabType: ''// 待办详情页回退时，待办页tab切换到之前状态
  },
  mutations: {
    // 登录
    login (state, payload) {
      axios({
        url: state.url + '/wechat/login/binding',
        method: 'post',
        transformRequest: [
          function (data) {
            let ret = ''
            for (let it in data) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
          }
        ],
        data: {
          openid: state.openId,
          accounts: payload.accounts,
          password: payload.password
        }
      }).then((response) => {
        if (response.data) {
          if (response.data.success === true) {
            state.isLogin = true
            state.userInfo = response.data.account
            state.token = response.data.token
            router.push({ name: 'Home' })
          } else if (response.data.success === false) {
            state.isLogin = false
          }
        }
        Vue.$vux.alert.show({
          title: response.data.msg
        })
        setTimeout(() => {
          Vue.$vux.alert.hide()
        }, 2000)
      }).catch((response) => {
        console.log(response)
      })
    },
    // 退出
    logout (state) {
      axios({
        url: state.url + '/wechat/login/unbind',
        method: 'get'
      }).then((response) => {
        state.isLogin = false
        state.userInfo = {}
        state.token = ''
        Vue.$vux.alert.show({
          title: response.data.msg
        })
        setTimeout(() => {
          Vue.$vux.alert.hide()
          router.push({ name: 'Home' })
        }, 1000)
      }).catch((response) => {
        console.log(response)
      })
    },
    setStateVal (state, payload) { // 其他组件给vuex-state赋值
      state.url = payload.url
      state.token = payload.token
      state.userInfo.accounts = payload.userName
    },
    setIsLogin (state, status) {
      state.isLogin = status
    },
    setTokenVal (state, token) {
      state.token = token
    },
    setOpenIdVal (state, openId) {
      state.openId = openId
    },
    setUserInfo (state, info) {
      state.userInfo = info
    }
  },
  actions: {
    // login (contexts, payload) {
    // const url = contexts.state.url + '/wechat/login/bindingWithMicroServe'
    // const params = {
    //   openid: contexts.state.openId,
    //   accounts: payload.accounts,
    //   password: payload.password
    // }
    // http.post(url, params).then((response) => {
    //   if (response.data.success === true) {
    //     contexts.state.isLogin = true
    //     contexts.state.userInfo = response.data.account
    //     contexts.state.token = response.data.token
    //     // contexts.commit('setIsLogin')
    //     // contexts.commit('someOtherMutation')
    //     // contexts.commit('setOpenIdVal')
    //     router.push({ name: 'Home' })
    //   } else if (response.data.success === false) {
    //     contexts.state.isLogin = false
    //   }
    // })
    // }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js